import HandlesPricing from './HandlesPricing'
import HandlesFormatting from './HandlesFormatting'
import HandlesHashGeneration from './HandlesHashGeneration'

export default {
  mixins: [
    HandlesFormatting,
    HandlesHashGeneration,
    HandlesPricing
  ],
  data: () => ({
    model: {
      organization_type: 2,
      plan_type: 2,
      size: 10000,
      yearly: true,
      add_ons: [{
        id: 1,
        label: 'Full Community Management',
        description: 'Are you and your team too busy to manage your organization’s networking community? Zenvoy can do it for you.'
      }],
      currency: 1
    },
    defaultAddOns: {
      2: [{
        id: 1,
        label: 'Full Community Management',
        description: 'Are you and your team too busy to manage your organization’s networking community? Zenvoy can do it for you.'
      }],
      3: [{
        id: 1,
        label: 'Full Community Management',
        description: 'Are you and your team too busy to manage your organization’s networking community? Zenvoy can do it for you.'
      }, {
        id: 2,
        label: 'Single Sign-On Support (SSO)',
        price: 5000,
        enterprise: true,
        monthly: 250,
        description: 'Will your organization need users to sign-in with a preexisting set of credentials?'
      }, {
        id: 3,
        label: 'Dedicated Server',
        price: 5000,
        monthly: 5000,
        description: 'Does your organization require extensive levels of additional data security, HIPAA, Data Loss Prevention (DLP), e-Discovery & offline backup providers?'
      }]
    },
    planTypes: {
      1: 'Basic Plan',
      2: 'Plus Plan',
      3: 'Enterprise Plan'
    }
  }),
  computed: {
    planType () {
      if (this.modalParams) {
        return this.modalParams.name
      }

      if (this.model.plan_type) {
        return this.planTypes[this.model.plan_type]
      }

      return false
    },
    isEnterprise () {
      return this.model.plan_type === 3
    }
  }
}
